import script from "./ConfirmationModalBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationModalBase.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationModalBase.vue?vue&type=style&index=0&id=ccfa4474&lang=css"
import "./ConfirmationModalBase.vue?vue&type=style&index=1&id=ccfa4474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfa4474"]])

export default __exports__